import { render, staticRenderFns } from "./IconHeart.vue?vue&type=template&id=d147ec5e"
import script from "./IconHeart.vue?vue&type=script&lang=js"
export * from "./IconHeart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports